<template>
  <main class="c-app-content">
    <div class="c-app-title">
      <div>
        <h1>Danh sách ghép cặp Bác sỹ - Tình nguyện viên</h1>
      </div>
      <ul class="c-app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><router-link to="/">Callio</router-link></li>
        <li class="breadcrumb-item"><router-link to="/contact">{{ $t('contacts') }}</router-link></li>
        <li class="breadcrumb-item active">Danh sách ghép cặp Bác sỹ - Tình nguyện viên</li>
      </ul>
    </div>
    <div class="col" v-if="firstLoading">
      <skeleton-loading>
        <row>
          <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
        </row>
        <row>
          <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
        </row>
      </skeleton-loading>
    </div>
    <div class="tile" v-else>
      <div class="c-action">
        <div class="row" v-if="!['bac-sy', 'nvyt'].includes($store.state.user.role)">
          <div class="col-lg-3 c-action__left">
            <span class="c-action__count">
                {{ $t('listSummary', [firstItemOfPage, lastItemOfPage, itemCount, 'nhóm']) }}
            </span>
          </div>
          <div class="col-lg-9 c-action__right">
            <user-group-select :model="filterFormModel" attribute="group" is-filter @change="load" :ids="groupIds"
                place-holder="Chọn nhóm" v-if="!['bac-sy-truong-nhom', 'bac-sy', 'nvyt'].includes($store.state.user.role)"></user-group-select>
            <user-select :model="filterFormModel" attribute="doctorUser" :group-filter="filterFormModel.group"
                 @change="search" :isFilter="true" place-holder="Chọn bác sỹ" role-filter="bac-sy"></user-select>
            <user-select :model="filterFormModel" attribute="followUser" :group-filter="filterFormModel.group"
              @change="search" :isFilter="true" place-holder="Chọn TNV" role-filter="nvyt"></user-select>
            <button class="btn btn-sm btn-primary" @click="search"><i class="fa fa-refresh mr-0"></i></button>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 c-action__left">
          </div>
          <div class="col-lg-9 c-action__right">
            <b-button class="btn btn-success btn-sm" v-if="!['bac-sy', 'nvyt'].includes($store.state.user.role)"
                      @click="create" data-toggle="modal" data-target="#partner-addnew">
              <i class="icon12-add-white icon-left"></i>{{ $t('create') }}
            </b-button>
          </div>
        </div>
      </div>
      <div v-if="listLoading" class="text-center text-primary">
        <b-spinner></b-spinner>
      </div>
      <div v-if="!listLoading && !itemCount" class="text-center text-danger">
        {{ $t('emptyList') }}
      </div>
      <div v-if="!listLoading && itemCount" class="c-template-table table-responsive">
        <table class="table table-bordered table-more table-hover">
          <thead>
          <tr>
            <th class="th-check">#</th>
            <th>Nhóm</th>
            <th>Bác sĩ phụ trách</th>
            <th>Tình nguyện viên</th>
            <th class="th-80"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in items" :key="item._id">
            <td class="th-check">{{index + 1}}</td>
            <td>{{ item.group ? item.group.name : $t('unknown') }}</td>
            <td v-if="item.doctorUser">
              <p>Họ tên: <b>{{item.doctorUser.name}}</b></p>
              <p>Email: <b>{{item.doctorUser.email}}</b></p>
              <p>SĐT: <b>{{item.doctorUser.phone ? item.doctorUser.phone : 'Chưa cập nhật'}}</b></p>
              <p>Số nhánh: <a href="javascript:;" @click="makeCall(item.doctorUser.ext)" v-b-tooltip="$t('clickToCallLocal')"><b>{{item.doctorUser.ext}}</b></a></p>
              <p>Lần online cuối:
                <b v-if="item.doctorUser.lastOnlineTime">{{item.doctorUser.lastOnlineTime | moment('DD/MM/YY HH:mm')}}</b>
                <b v-else>Chưa online</b>
              </p>
            </td>
            <td v-else>Chưa có BS</td>
            <td>
              <template v-if="item.followUsers && item.followUsers.length">
                <p>Tổng số: <b>{{item.followUsers.length}}</b> TNV:</p><br>
                <p v-for="(u, index) of item.followUsers" :key="u._id">
                  <b>{{index + 1}}</b> |
                  <span>Họ tên: <b>{{u.name}}</b></span> |
                  <span>Email: <b>{{u.email}}</b></span> |
                  <span>SĐT: <b>{{u.phone ? u.phone : 'Chưa cập nhật'}}</b></span> |
                  <span>Số nhánh: <a href="javascript:;" @click="makeCall(u.ext)" v-b-tooltip="$t('clickToCallLocal')"><b>{{u.ext}}</b></a></span> |
                  <span>Lần online cuối:
                    <b v-if="u.lastOnlineTime">{{u.lastOnlineTime | moment('DD/MM/YY HH:mm')}}</b>
                    <b v-else>Chưa online</b>
                  </span>
                </p>
              </template>
              <span v-else>Đã có cặp nhưng trong cặp chưa có TNV nào</span>
            </td>
            <td>
              <button class="btn btn-sm btn-outline-gray mr-1 mb-1" @click="update(item._id)" v-if="['bac-sy-truong-nhom', 'owner'].includes($store.state.user.role)">
                <i class="fa fa-edit"></i> Sửa</button>
              <button class="btn btn-sm btn-outline-gray mr-1 mb-1" @click="del(item._id)"  v-if="['bac-sy-truong-nhom', 'owner'].includes($store.state.user.role)">
                <i class="icon12-delete-primary"></i> Xoá</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="c-paging" v-if="itemCount > filterFormModel.pageSize">
        <b-pagination size="sm" class="pagination pagination-sm justify-content-center"
                      v-model="filterFormModel.page" :total-rows="itemCount"
                      :per-page="filterFormModel.pageSize" @input="load">
        </b-pagination>
      </div>
    </div>
    <nhom-n-v-y-t-modal ref="modal"></nhom-n-v-y-t-modal>
  </main>
</template>

<script>
import list from '@/mixins/List';
import _ from 'lodash';
import UserSelect from "@/components/UserSelect";
import UserGroupSelect from "@/components/UserGroupSelect";
import NhomNVYTModal from "./NhomNVYTModal";
export default {
  components: {
    UserSelect,
    UserGroupSelect,
    NhomNVYTModal
  },
  mixins: [list],
  data: function () {
    return {
      service: "/nhom-nvyt",
      autoLoad: true,
      reloadBus: 'reloadNhomBacSy',
      defaultFilterFormModel: {
        group: this.$store.state.user.role === 'bac-sy-truong-nhom' ? this.$store.state.user.group : null,
      },
    };
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    makeCall(number) {
      this.$bus.$emit('makeCall', number);
    },
    create() {
      this.$refs.modal.create();
    },
    update(id) {
      this.$refs.modal.update(id);
    },
    del(id) {
      this.$refs.modal.del(id);
    }
  },
  computed: {
    customerCreatePermission() {
      return this.$store.state.user.permissions.includes('customerCreate');
    },
    customerExportPermission() {
      return this.$store.state.user.permissions.includes('customerExport');
    },
    groupIds() {
      if (this.$store.state.user.permissions.includes('customerListGroup') && !this.$store.state.user.permissions.includes('customerListAll')) {
        return this.$store.state.user.roleGroups
      }
      return null
    },
  }
}
</script>
